const root = "/users";

export const UserRoutesMap = {
  root: root,
  add: `${root}/add`,
  detail: (userId: string) => ({
    root: `${root}/${userId}`,
    products: `${root}/${userId}/products`,
    audit: `${root}/${userId}/audit`,
    delete: `${root}/${userId}/delete`,
  }),
};
